import { Component } from '@angular/core';

import { BaseComponent } from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-range',
  templateUrl: './range.component.html',
  host: {
    class: 'uex-input-range'
  }
})
export class InputRangeComponent extends BaseComponent<string> {

}
